<template lang="pug">
  .product-invoice
    y-dialog(fill-height fluid v-model="showModal" scrollable transition="fade-transition" persistent max-width="600px")
      v-card
        v-card-title(style="height:56px;")
          .h6.basic800--text {{ $t('embed_form') }}
        v-divider.basic300

        v-layout.my-6(v-if="!iframe || !floatingButtonCopy")
          v-row.fill-height.ma-0(align='center' justify='center')
            v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
        v-card-text.pa-0(v-else)
          v-container
            div.py-1
              v-btn.font-weight-bold(color="green accent-4" dark block depressed :outlined="type !== 'floating'" @click="type = 'floating'" style="text-transform: none;")
                template
                  v-icon(left) mdi-whatsapp
                  div {{ $t('floating_button') }}
            div.py-1
              v-btn.font-weight-bold(color="blue accent-4" dark block depressed :outlined="type !== 'iframe'" @click="type = 'iframe'" style="text-transform: none;")
                template
                  v-icon(left) mdi-code-not-equal-variant
                  div iframe
            div.mt-3 {{ $t('text') }}
            v-card.pa-3.mt-4.black.lighten-1.elevation-0.white--text(style="white-space: pre-wrap; font-family: 'Courier New', Courier, monospace;")
              div(v-if="type === 'floating'") {{ floatingButton }}
              div(v-if="type === 'iframe'") {{ iframe }}
            

        v-card-actions
          v-spacer
          v-btn(color='white', text @click='showModal = false')
            .button-Aa-small.primary400--text {{ $t('close') }}
          v-btn.mr-2(v-clipboard:copy="getEmbedCode()" color='textColorAccent' :dark="!(!iframe || !floatingButtonCopy)" depressed height=32 @click="copy" :disabled="!iframe || !floatingButtonCopy")
            .button-AA-small.basic100--text {{ $t('copy') }}
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'EmbedFormDialog',
  props: ['open', 'form', 'company'],
  components: { },
  data: () => ({
    type: 'floating',
    iframe: null,
    floatingButton: null,
    floatingButtonCopy: null
  }),
  computed: {
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  mounted () {
    this.$axios.get(`https://${this.company.slug}.${process.env.VUE_APP_BASE_DOMAIN}/embedform/iframe.txt`)
      .then(({ data }) => {
        this.iframe = data.toString().replace('src=""', `src="${this.getFormURL()}"`)
      })
      .catch(() => {})
    this.$axios.get(`https://${this.company.slug}.${process.env.VUE_APP_BASE_DOMAIN}/embedform/floating.txt`)
      .then(({ data }) => {
        this.floatingButton = data.toString().replace('src=""', `src="${this.getEmbedFloatingURL()}"`)
      })
      .catch(() => {})
    this.$axios.get(`https://${this.company.slug}.${process.env.VUE_APP_BASE_DOMAIN}/embedform/floating-copy.txt`)
      .then(({ data }) => {
        this.floatingButtonCopy = data.toString().replace('src=""', `src="${this.getEmbedFloatingURL()}"`)
      })
      .catch(() => {})
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    getFormURL () {
      return `https://${process.env.VUE_APP_SHORT_URL_DOMAIN}/${this.form.slug}`
    },
    getEmbedFloatingURL () {
      return `https://${process.env.VUE_APP_SHORT_URL_DOMAIN}/${this.form.slug}/embed`
    },
    getEmbedCode () {
      if (this.type === 'iframe') {
        return this.iframe
      }
      return this.floatingButtonCopy
    },
    copy () {
      this.showMessage(['success', this.$t('success_message.code_copied_to_clipboard')])
    }
  }
}
</script>

<style lang="scss" scoped>
</style>

<i18n>
{
  "en": {
    "text": "Copy the following content, and paste it on your website."
  },
  "id": {
    "text": "Salin konten berikut, dan tempel di situs web kamu"
  }
}
</i18n>
